import BaseModelComponent from "../../base/base_model";
import _ from '../../utils/underscore';
import * as WelcomeConst from "./welcome_const";
import {PRIORITY_LEVEL} from '../../services/overlay_manager/overlay_manager_levels';

/**
 * @constant
 * @type {string}
 */
const LOGIN_KEY = 'login',
    LOGGEDIN_KEY = 'loggedin',
    BOTH = 'both';

class WelcomeModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'WelcomeModel';


    /**
     * @property
     * @type {{showBalance: string, showRememberme: string}}
     * @private
     */
    _map = {
        showBalance       : LOGGEDIN_KEY,
        showRememberme    : LOGIN_KEY,
        showRegister      : LOGIN_KEY,
        showMenu          : LOGGEDIN_KEY,
        showCashier       : LOGGEDIN_KEY,
        showForgotUsername: LOGIN_KEY,
        showUsername      : LOGGEDIN_KEY,
        showUserBadge     : LOGGEDIN_KEY,
        cashierOpenType   : BOTH,
        gametype          : BOTH,
        gameName          : BOTH,
        isReal            : BOTH,
        marketingDataFn   : LOGIN_KEY,
        postCTAClickedFn  : LOGGEDIN_KEY,
        postLoginShowGreeting: LOGGEDIN_KEY,
        preLoginLayoutPC: LOGIN_KEY,
        preLoginLayoutMobile: LOGIN_KEY,
        postLoginLayoutPC: LOGGEDIN_KEY,
        postLoginLayoutMobile: LOGGEDIN_KEY,
        styleSelectors: BOTH
    };


    /**
     * @param params
     */
	init(params = {}) {
        this
            ._setLayout(params.layout)
            ._setLayoutType(params.layoutType)
            ._setShowBalance(params.showBalance)
            ._setShowRegister(params.showRegister)
            ._setShowMenu(params.showMenu)
            ._setGameType(params.gametype)
            ._setGameName(params.gameName)
            ._setGameIsReal(params.isReal)
            ._setMarketingData(params.marketing)
            ._setPostCTAClickedFn(params.postCtaClicked)
            ._setEnvironment(params.env)
            ._setShowRememberme(params.showRememberme)
            ._setShowCashier(params.showCashier)
            ._setSilentMode(params.silentMode)
            ._setOverlayPriority(params.overlayPriority)
            ._setShowUsername(params.showUsername)
            ._setShowUserBadge(params.showUserBadge)
            ._setCashierOpenType(params.cashierOpenType)
            ._setIsDirective(params.isDirective)
            ._setShowForgotUsername(params.showForgotUsername)
            ._setPostLoginShowGreeting(params.postLoginShowGreeting)
            ._setPreLoginStyleMobile(params.preLoginStyleMobile)
            ._setPreLoginStylePC(params.preLoginStylePc)
            ._setPreLoginLayoutPC(params.preLoginLayoutPc)
            ._setPreLoginLayoutMobile(params.preLoginLayoutMobile)
            ._setPostLoginLayoutPC(params.postLoginLayoutPc)
            ._setPostLoginLayoutMobile(params.postLoginLayoutMobile)
            ._setStyleSelectors(params.styleSelectors);
    }


    /**
     * Set the layout that will wrap the welcome component.
     *
     * @param layout
     * @returns {WelcomeModel}
     * @private
     */
    _setLayout(layout = '') {
        let _layout = WelcomeConst.LAYOUT_PATTERN[layout.toUpperCase()];
        if (!_layout) {
            _layout = WelcomeConst.LAYOUT_PATTERN.BUTTONS;
        }

        this._layout = _layout;

        return this;
    }


    /**
     * Set market data global scope fn string name.
     *
     * @param fnName
     * @returns {WelcomeModel}
     * @private
     */
    _setMarketingData(fnName) {
        if (!_.isString(fnName)) {
            return this;
        }

        this._marketingDataFn = fnName;
        return this;
    }


    /**
     * Set handle function that will be called on balance click
     * @param fnName
     * @returns {WelcomeModel}
     * @private
     */
    _setPostCTAClickedFn(fnName) {
        if (!_.isString(fnName)) {
            return this;
        }

        this._postCTAClickedFn = fnName;
        return this;
    }


    /**
     * Set game type will be valid only for game panel.
     *
     * @param gametype
     * @returns {WelcomeModel}
     * @private
     */
    _setGameType(gametype) {
        if (!_.isNumber(gametype)) {
            return this;
        }

        this._gametype = gametype;
        return this;
    }


    /**
     * Set game name will be valid only for game panel.
     *
     * @param gameName
     * @returns {WelcomeModel}
     * @private
     */
    _setGameName(gameName) {
        if (!_.isString(gameName)) {
            return this;
        }

        this._gameName = gameName;
        return this;
    }


    /**
     * Set game name will be valid only for game panel.
     *
     * @param isReal
     * @returns {WelcomeModel}
     * @private
     */
    _setGameIsReal(isReal) {
        if (!_.isBoolean(isReal)) {
            return this;
        }

        this._isReal = isReal;
        return this;
    }


    /**
     *
     * @param isDirective
     * @returns {WelcomeModel}
     * @private
     */
    _setIsDirective(isDirective) {
        if (!_.isBoolean(isDirective)) {
            this._isDirective = false;
            return this;
        }

        this._isDirective = isDirective;
        return this;
    }


    /**
     * Set the environment the component opened in.
     *
     * @param env
     * @returns {WelcomeModel}
     * @private
     */
    _setEnvironment(env = 'lobby') {
        if (!_.isString(env)) {
            this._environment = 'lobby';
            return this;
        }

        this._environment = env;
        return this;
    }


    /**
     * Define the silent mode of the component.
     *
     * @param silentMode
     * @returns {WelcomeModel}
     * @private
     */
    _setSilentMode(silentMode) {
        if (_.isString(silentMode)) {
            silentMode = 'true' === silentMode;
        }

        if (!_.isBoolean(silentMode)) {
            silentMode = false;
        }

        this._silentMode = silentMode;
        return this;
    }


    /**
     *
     * @param cashierOpenType
     * @returns {GameServiceModel}
     * @private
     */
    _setCashierOpenType(cashierOpenType) {
        if (_.isString(cashierOpenType)) {
            cashierOpenType = Number(cashierOpenType);

            if (Number.isNaN(cashierOpenType)) {
                cashierOpenType = 0;
            }
        }

        if (!_.isNumber(cashierOpenType)) {
            this._cashierOpenType = 0;
            return this;
        }

        this._cashierOpenType = cashierOpenType;
        return this;
    }


    /**
     * Set the component overlay priority.
     *
     * @param overlayPriority
     * @returns {WelcomeModel}
     * @private
     */
    _setOverlayPriority(overlayPriority) {
        this._overlayPriority = overlayPriority && _.isString(overlayPriority) ? overlayPriority : PRIORITY_LEVEL.LOGIN;
        return this;
    }


    /**
     * Set layout type. (default is 1).
     *
     * @param layoutType
     * @returns {WelcomeModel}
     * @private
     */
    _setLayoutType(layoutType) {
        if (this._isValidLayoutParam(layoutType)) {
            this._layoutType = Number(layoutType);
            return this;
        }

        this._layoutType = WelcomeConst.LAYOUT_TYPE.DEFAULT_TYPE;
        return this;
    }


    /**
     * Set the show balance flag.
     *
     * @param showBalance
     * @returns {WelcomeModel}
     * @private
     */
    _setShowBalance(showBalance = 'true') {
        if (_.isString(showBalance)) {
            if (!this._isValidShowParam(showBalance)) {
                this._showBalance = false;
                return this;
            }

            this._showBalance = 'true' === showBalance;
            return this;
        }

        if (_.isBoolean(showBalance)) {
            this._showBalance = showBalance;
            return this;
        }

        return this;
    }


    /**
     *
     * @param showUsername
     * @returns {WelcomeModel}
     * @private
     */
    _setShowUsername(showUsername = 'true') {
        if (_.isString(showUsername)) {
            if (!this._isValidShowParam(showUsername)) {
                this._showUsername = false;
                return this;
            }

            this._showUsername = 'true' === showUsername;
            return this;
        }

        if (_.isBoolean(showUsername)) {
            this._showUsername = showUsername;
            return this;
        }

        return this;
    }


    /**
     * Set if show user badge in mobile
     * @param showUserBadge
     * @returns {WelcomeModel}
     * @private
     */
    _setShowUserBadge(showUserBadge = 'true') {
        this._showUserBadge = _.toBoolean(showUserBadge);
        return this;
    }


    /**
     * Set the show register flag.
     *
     * @param showRegister
     * @returns {WelcomeModel}
     * @private
     */
    _setShowRegister(showRegister = 'true') {
        if (_.isString(showRegister)) {
            if (!this._isValidShowParam(showRegister)) {
                this._showRegister = false;
                return this;
            }

            this._showRegister = 'true' === showRegister;
            return this;
        }

        if (_.isBoolean(showRegister)) {
            this._showRegister = showRegister;
            return this;
        }

        return this;
    }

    /**
     * Set the show menu flag.
     *
     * @param showMenu
     * @returns {WelcomeModel}
     * @private
     */
    _setShowMenu(showMenu = 'false') {
        if (_.isString(showMenu)) {
            if (!this._isValidShowParam(showMenu)) {
                this._showMenu = false;
                return this;
            }

            this._showMenu = 'true' === showMenu;
            return this;
        }

        if (_.isBoolean(showMenu)) {
            this._showMenu = showMenu;
            return this;
        }

        return this;
    }


    /**
     * Set the remember me flag.
     *
     * @param showRememberme
     * @returns {WelcomeModel}
     * @private
     */
    _setShowRememberme(showRememberme = 'true') {
        if (_.isString(showRememberme)) {
            if (!this._isValidShowParam(showRememberme)) {
                this._showRememberme = false;
                return this;
            }

            this._showRememberme = 'true' === showRememberme;
            return this;
        }

        if (_.isBoolean(showRememberme)) {
            this._showRememberme = showRememberme;
            return this;
        }

        return this;
    }


    /**
     * Set the show cashier flag.
     *
     * @param showCashier
     * @returns {WelcomeModel}
     * @private
     */
    _setShowCashier(showCashier = 'true') {
        if (_.isString(showCashier)) {
            if (!this._isValidShowParam(showCashier)) {
                this._showCashier = false;
                return this;
            }

            this._showCashier = 'true' === showCashier;
            return this;
        }

        if (_.isBoolean(showCashier)) {
            this._showCashier = showCashier;
            return this;
        }

        return this;
    }


    /**
     * Set the show forgot flag.
     *
     * @param showForgotUsername
     * @returns {WelcomeModel}
     * @private
     */
    _setShowForgotUsername(showForgotUsername = 'true') {
        if (_.isString(showForgotUsername)) {
            if (!this._isValidShowParam(showForgotUsername)) {
                this._showForgotUsername = false;
                return this;
            }

            this._showForgotUsername = 'true' === showForgotUsername;
            return this;
        }

        if (_.isBoolean(showForgotUsername)) {
            this._showForgotUsername = showForgotUsername;
            return this;
        }

        return this;
    }


    /**
     * Set the show greeting flag
     * @param postLoginShowGreeting
     * @private
     */
    _setPostLoginShowGreeting(postLoginShowGreeting) {
        this._postLoginShowGreeting = _.toBoolean(postLoginShowGreeting);
        return this;
    }


    /**
     * Set the pre login style mobile
     *
     * @param preLoginStyleMobile
     * @returns {WelcomeModel}
     * @private
     */
    _setPreLoginStyleMobile(preLoginStyleMobile) {
        this._preLoginStyleMobile = preLoginStyleMobile;

        return this;
    }


    /**
     * Set the pre login style PC
     *
     * @param preLoginStylePC
     * @returns {WelcomeModel}
     * @private
     */
    _setPreLoginStylePC(preLoginStylePC) {
        this._preLoginStylePC = preLoginStylePC;

        return this;
    }


    /**
     * Set overriding for pc pre login layout
     * @param preLoginLayoutPC
     * @returns {WelcomeModel}
     * @private
     */
    _setPreLoginLayoutPC(preLoginLayoutPc) {
        this._preLoginLayoutPC = preLoginLayoutPc;
        return this;
    }


    /**
     * Set overriding for mobile pre login layout
     * @param preLoginLayoutMobile
     * @returns {WelcomeModel}
     * @private
     */
    _setPreLoginLayoutMobile(preLoginLayoutMobile) {
        this._preLoginLayoutMobile = preLoginLayoutMobile;
        return this;
    }


    /**
     * Set overriding for pc post layout
     * @param postLoginLayoutPC
     * @returns {WelcomeModel}
     * @private
     */
    _setPostLoginLayoutPC(postLoginLayoutPc) {
        this._postLoginLayoutPC = postLoginLayoutPc;
        return this;
    }


    /**
     * Set overriding for mobile post layout
     * @param postLoginLayoutMobile
     * @returns {WelcomeModel}
     * @private
     */
    _setPostLoginLayoutMobile(postLoginLayoutMobile) {
        this._postLoginLayoutMobile = postLoginLayoutMobile;
        return this;
    }

    /**
     * Set custom selectors to component HTML elements
     * @param styleSelectors
     * @returns {WelcomeModel}
     * @private
     */
    _setStyleSelectors(styleSelectors) {
        this._styleSelectors = styleSelectors;
        return this;
    }


    /**
     * Validation function for show params attribute
     * To validate that the client data sent is valid.
     *
     * @param showParam
     * @returns {boolean}
     * @private
     */
    _isValidShowParam(showParam) {
        if ('true' === showParam) {
            return true;
        }

        if ('false' === showParam) {
            return true;
        }

        return false;
    }


    /**
     * Validation function for layout params attribute
     * To validate that the client data sent is valid.
     *
     * @param layoutType
     * @returns {boolean}
     * @private
     */
    _isValidLayoutParam(layoutType) {
        switch(layoutType) {
            case '1':
                return true;
            case '2':
                return true;
            case '3':
                return true;
            case '4':
                return true;
            default:
                return false;
        }
    }


    /**
     * Get map by state.
     *
     *
     * @param state
     * @returns {{}}
     */
    getMapByState(state) {
        let map = {};

        for(let prop in this._map) {
            if (this._map[prop] === BOTH) {
                map[prop] = this['_' + prop];
                continue;
            }

            if (!(this._map[prop] === state)) {
                continue;
            }

            map[prop] = this['_' + prop];
        }

        return Object.assign({}, map, this.getLayout()[state], {
            env: this._environment,
            layoutType: this.getLayoutType(), // Default buttons
            overlayPriority: this._overlayPriority, // Default popup.
            silentMode: this._silentMode // Default false
        });
    }


    /**
     *
     * @returns {LAYOUT_PATTERN.DEFAULT|{login, loggedin}|*}
     * @public
     */
    getLayout() {
        return this._layout;
    }


    /**
     * Get layout type.
     *
     * @returns {*}
     */
    getLayoutType() {
        return this._layoutType;
    }


    /**
     * Get pre login style PC.
     *
     * @returns {*}
     */
    getPreLoginStylePC() {
        return this._preLoginStylePC;
    }


    /**
     * Get pre login style mobile.
     *
     * @returns {*}
     */
    getPreLoginStyleMobile() {
        return this._preLoginStyleMobile;
    }


    /**
     *
     * @returns {*|boolean}
     */
    getIsDirective() {
        return this._isDirective;
    }


    /**
     *
     * @returns {number|*}
     */
    getCashierOpenType() {
        return this._cashierOpenType;
    }


    /**
     * Get environment where the component loaded at.
     *
     * @returns {string|*}
     */
    getEnvironment() {
        return this._environment;
    }


    /**
     * Get market data fn string.
     *
     * @returns {*}
     */
    getMarketingData() {
        return this._marketingDataFn;
    }


    /**
     * Get external handle function for balance click
     * @returns {*}
     */
    getPostCTAClickedFn() {
        return this._postCTAClickedFn;
    }


    /**
     * Get if show register button in pre login layout
     * @returns {*}
     */
    getPreLoginShowRegister() {
        return this._preLoginShowRegister;
    }


    /**
     * Get layout name for pre login PC
     * @returns {*}
     */
    getPreLoginLayoutPC() {
        return this._preLoginLayoutPC;
    }


    /**
     * Get layout name for pre login Mobile
     * @returns {*}
     */
    getPreLoginLayoutMobile() {
        return this._preLoginLayoutMobile;
    }


    /**
     * Get layout name for post login PC
     * @returns {*}
     */
    getPostLoginLayoutPC() {
        return this._postLoginLayoutPC;
    }


    /**
     * Get layout name for post login Mobile
     * @returns {*}
     */
    getPostLoginLayoutMobile() {
        return this._postLoginLayoutMobile;
    }


    /**
     * Get custom css selectors for HTML elements
     * @returns {*}
     */
    getStyleSelectors() {
        return this._styleSelectors;
    }
}
export default WelcomeModel;